import { render, staticRenderFns } from "./taskToInqu.vue?vue&type=template&id=71422357&scoped=true&"
import script from "./taskToInqu.vue?vue&type=script&lang=js&"
export * from "./taskToInqu.vue?vue&type=script&lang=js&"
import style0 from "./taskToInqu.vue?vue&type=style&index=0&id=71422357&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71422357",
  null
  
)

export default component.exports